import React from 'react'
import PropTypes from 'prop-types'
import styles from './ItalicSlatePlugin.scss'

const ItalicNode = ({ attributes, children }) => (
  <span {...attributes} style={{fontStyle: 'italic'}} className={styles.ItalicNode}>
    {children}
  </span>
)

ItalicNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default ItalicNode



// WEBPACK FOOTER //
// ./src/components/ItalicSlatePlugin/ItalicNode.js